module.exports = __webpack_public_path__ + "img/29_41.5ef7b1ec.png";